"use client";
import React, { useState } from "react";

import PrismicLinkTag from "@sendmagic/prismic-nextjs/src/components/LinkTag";
import PrismicImgix from "@sendmagic/prismic-nextjs/src/components/Imgix";

import { checkContentPresence } from "@sendmagic/prismic-nextjs/src/helpers/prismic";
import { textResolver } from "@sendmagic/prismic-nextjs/src/constants/text-resolver";

import defaultStyles from "../main.module.scss";

const RightSection = ({
  tab: { image, heading, description },
  sliceStyles: styles = defaultStyles,
}) => (
  <div className={styles.tabsContentImgBlock}>
    <div className={styles.tabsContentImgHolder}>
      <PrismicImgix
        alt={image?.alt}
        src={image?.url}
        className={styles.tabsImageSize}
        desktop="600px"
      />
    </div>
    <div className={styles.tabsHeader}>
      {checkContentPresence(heading) && (
        <h3 className={styles.tabsImgTitle}>
          {textResolver(heading, { convertLabelToModular: true })}
        </h3>
      )}
      {checkContentPresence(description) && (
        <div className={styles.tabsBlockDescription}>
          {textResolver(description, { convertLabelToModular: true })}
        </div>
      )}
    </div>
  </div>
);

const ToggleableTabs = ({ doc, sliceStyles: styles = defaultStyles }) => {
  const [activeTab, setActiveTab] = useState(doc?.items[0]);

  const { title, link, link_text, bg_color } = doc?.primary || {};
  const sectionStyle = { backgroundColor: bg_color };

  return (
    <div className={styles.toggleableTabsSlice} style={sectionStyle}>
      <div className={styles.tabsSliceContainer}>
        <div className={styles.tabsSliceContentHolder}>
          {checkContentPresence(title) && (
            <h2 className={styles.tabsSliceTitle}>
              {textResolver(title, { convertLabelToModular: true, convertToNormalText: true })}
            </h2>
          )}
          <div className={styles.tabsContentSection}>
            <div className={styles.tabsContentLinks}>
              {doc?.items?.map(({ icon_image, heading, description, image }, idx) => {
                const activeClass = heading === activeTab?.heading ? styles.active : "";
                return (
                  <div
                    className={`${styles.tabsContentLinksRow} ${activeClass}`}
                    key={`thumbnail-${idx}`}
                    onClick={() => setActiveTab({ heading, description, image })}
                  >
                    <div className={styles.tabLinksIconHolder}>
                      {icon_image?.url && (
                        <PrismicImgix
                          alt={icon_image?.alt}
                          src={icon_image?.url}
                          className={styles.tabLinksIcon}
                          desktop="100px"
                        />
                      )}
                    </div>
                    {checkContentPresence(heading) && (
                      <h3 className={styles.tabsLinkText}>
                        {textResolver(heading, { convertLabelToModular: true })}
                      </h3>
                    )}
                  </div>
                );
              })}
            </div>
            <RightSection tab={activeTab} />
          </div>
        </div>
        {link?.url && (
          <div className={styles.tabsSliceCtaRow}>
            <PrismicLinkTag
              urlText={link_text}
              url={link?.url}
              target={link?.target}
              className={styles.tabsSliceCta}
              convertLabelToModular
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ToggleableTabs;
